/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Freecta1Inputs */

const zh_pricing_freecta1 = /** @type {(inputs: Pricing_Freecta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费开始`)
};

const en_pricing_freecta1 = /** @type {(inputs: Pricing_Freecta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Started Free`)
};

const es_pricing_freecta1 = /** @type {(inputs: Pricing_Freecta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empezar Gratis`)
};

/**
* | output |
* | --- |
* | "Get Started Free" |
*
* @param {Pricing_Freecta1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const pricing_freecta1 = /** @type {((inputs?: Pricing_Freecta1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Freecta1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_freecta1(inputs)
	if (locale === "en") return en_pricing_freecta1(inputs)
	return es_pricing_freecta1(inputs)
});
export { pricing_freecta1 as "pricing_freeCta" }